import React, { useState } from 'react';
import { ActionIcon, Button, Group, Stack, Text, Tooltip } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import ArchimageModal from '../ArchimageModal';
import { getAccentColor } from '../../lib/theme';

export default function EmplacementsControlAlert() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip label="Accès sous contrôle" withArrow withinPortal openDelay={200}>
        <ActionIcon
          variant="light"
          color={getAccentColor()}
          size="input-sm"
          onClick={() => setOpen(true)}
          aria-label="Accès sous contrôle"
        >
          <IconAlertTriangle size={18} />
        </ActionIcon>
      </Tooltip>

      <ArchimageModal
        opened={open}
        onClose={() => setOpen(false)}
        title="Accès sous contrôle"
        size="sm"
      >
        <Stack gap="md">
          <Text size="sm">
            Attention : l&apos;accès à la gestion des emplacements doit être effectué sous contrôle.
          </Text>
          <Group justify="flex-end">
            <Button variant="default" onClick={() => setOpen(false)}>
              Fermer
            </Button>
          </Group>
        </Stack>
      </ArchimageModal>
    </>
  );
}
